import { useTranslation } from 'react-i18next';
import { LogoMark } from '@growhero/brand';
import { isApiError } from '@/lib/api';
import { Button } from '@/ui';

/** Calm loading screen: the mark gently "breathes". */
export function FullPageLoader() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        <LogoMark
          size={44}
          title={null}
          className="animate-[gh-breathe_1.8s_ease-in-out_infinite] motion-reduce:animate-none"
        />
        <span className="sr-only">Φόρτωση…</span>
      </div>
      <style>{`@keyframes gh-breathe{0%,100%{opacity:.45;transform:translateY(1px) scale(.97)}50%{opacity:1;transform:none}}`}</style>
    </div>
  );
}

export function FullPageError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  const network = isApiError(error) && error.code === 'network_error';
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-6">
      <div className="max-w-md text-center">
        <LogoMark size={40} title={null} tone="mono" className="mx-auto mb-6 text-ink-subtle" />
        <h1 className="display-heavy text-2xl">
          {network ? t('errors.networkTitle') : t('errors.genericTitle')}
        </h1>
        <p className="mt-2 text-ink-muted">
          {network ? t('errors.networkBody') : t('errors.genericBody')}
        </p>
        {isApiError(error) && error.requestId && (
          <p className="mt-3 font-mono text-xs text-ink-subtle">ref: {error.requestId}</p>
        )}
        {onRetry && (
          <Button className="mt-6" onClick={onRetry}>
            {t('actions.retry')}
          </Button>
        )}
      </div>
    </div>
  );
}
